export default __webpack_public_path__ + "locales/zh-CN/Notifications.json?hash=01a9586d77fa0c74c8991accd9b6114c";